import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import MobileHomeView from '../views/MobileHomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { deviceType: 'desktop' }
  },
  {
    path: '/mobile',
    name: 'mobileHome',
    component: MobileHomeView,
    meta: { deviceType: 'mobile' }
  },
  // 可以添加更多PC端和移动端的路由
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
